import {
    USERNAME_NO_SYMBOLS,
    USERNAME_TOO_LONG,
    USERNAME_TOO_SHORT,
} from "../constants";
import IError from "../interfaces/IError";

export default function validateUsername(username: string): IError[] {
    const MIN_USERNAME_LENGTH = 3;
    const MAX_USERNAME_LENGTH = 25;
    const ALLOWED_SYMBOLS_REGEX = /^[a-zA-Z0-9\-_]+$/;

    const errors: IError[] = [];

    if (username.length < MIN_USERNAME_LENGTH) {
        errors.push({
            data: {
                minLength: MIN_USERNAME_LENGTH,
            },
            type: USERNAME_TOO_SHORT,
        });
    }

    if (username.length > MAX_USERNAME_LENGTH) {
        errors.push({
            data: {
                maxLength: MAX_USERNAME_LENGTH,
            },
            type: USERNAME_TOO_LONG,
        });
    }

    if (!ALLOWED_SYMBOLS_REGEX.test(username)) {
        errors.push({ type: USERNAME_NO_SYMBOLS });
    }

    return errors;
}



// WEBPACK FOOTER //
// ./src/utils/validateUsername.ts